// 此action文件为定义微应用之间全局状态
// 引入qiankun的应用间通信方法initGlobalState
import { initGlobalState } from 'qiankun';

const initialState = {
        // 这里可以写初始化数据
        userInfo: { nickname: '' },
        showHeader: true,
        showAsider: true
    },
    actions = initGlobalState(initialState); //初始化state
// 监听actions全局公共状态数据的变化
// actions.onGlobalStateChange((state, prevState) => {
//     state = state;
// })
//按一级属性设置全局状态，微应用中只能修改已存在的一级属性
// actions.setGlobalState();
//移除当前应用的状态监听，微应用 umount 时会默认调用

actions.offGlobalStateChange();
export const initialGlobalState = initialState;
export default actions;
